import { CloseIcon } from 'components/icons'
import { useApp } from 'context/app-context'
import classNames from 'helpers/class-names'

const FlashNotice = () => {
  const { flashNotice, setFlashNotice, navigationCollapsed } = useApp()

  return (
    flashNotice && (
      <div
        role="alert"
        aria-label={flashNotice.message}
        className={classNames(
          'absolute left-1/2 top-5 z-50 mt-14 flex w-full -translate-x-1/2 transform flex-col px-4 sm:w-[512px] sm:px-0 md:mt-0',
          'font-body text-base font-semibold tracking-normal',
          { 'md:ml-18': navigationCollapsed, 'md:ml-36': !navigationCollapsed },
        )}>
        <div
          className={classNames(
            'hide-scrollbar flex max-h-[140px] w-full max-w-lg items-start gap-2 self-center overflow-y-scroll rounded-lg p-2 pl-3 shadow-md ',
            {
              'bg-warning text-gray': flashNotice.type === 'warning',
              'bg-danger text-white': flashNotice.type === 'danger',
              'bg-success text-white': flashNotice.type === 'success',
            },
          )}>
          <div className="mr-8 flex-1 whitespace-pre-line break-words">
            {flashNotice.message}
          </div>
          <button
            aria-label="Close"
            className="flex-0 fixed right-2 top-2 shrink-0 cursor-pointer items-start rounded-lg p-0.5 text-left transition-all duration-300
                   hover:bg-black/10 active:scale-90"
            onClick={() => setFlashNotice(null)}>
            <CloseIcon
              className={classNames('size-5', {
                'text-gray': flashNotice.type === 'warning',
                'text-white':
                  flashNotice.type === 'danger' ||
                  flashNotice.type === 'success',
              })}
            />
          </button>
        </div>
      </div>
    )
  )
}

export default FlashNotice
